import { tns } from 'tiny-slider/src/tiny-slider';
import { renderCustomQuestions } from './custom-questions';

window.tns = tns;
window.pmeRenderCustomQuestions = renderCustomQuestions;
